import React from "react";
import Home from "./components/Home";
import Whatsnew from "./components/Whatsnew";
import Products from "./components/Products";
import About from "./components/About";
import Contact from "./components/Contact";
import Footer from "./components/footer";

export default function App()
{
  return(
      <main className="main">
        <Home/>
        <Products/>
        <Whatsnew/>
        <About/>
        <Contact/> 
        <Footer/> 
      </main>
  );
}